import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  NotificationScheduleService
} from '../../services/notification-schedule.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-scheduler',
  templateUrl: './notification-scheduler.component.html'
})
export class NotificationSchedulerComponent {

  loading = false;
  successMessage = '';
  errorMessage = '';

  form = {
    title: '',
    description: '',
    applicationId: 2,
    daysOfWeek: [] as string[],
    isUnlimitedTime: false,
    startTime: '',
    endTime: '',
    intervalMinutes: null as number | null
  };

  days = [
    { label: 'Lundi', value: 'monday' },
    { label: 'Mardi', value: 'tuesday' },
    { label: 'Mercredi', value: 'wednesday' },
    { label: 'Jeudi', value: 'thursday' },
    { label: 'Vendredi', value: 'friday' },
    { label: 'Samedi', value: 'saturday' },
    { label: 'Dimanche', value: 'sunday' }
  ];

  constructor(private http: HttpClient, private notificationScheduleService :NotificationScheduleService,
                private router: Router
  ) {}

  submit() {
    this.successMessage = '';
    this.errorMessage = '';

    if (!this.form.title || !this.form.description || !this.form.applicationId) {
      this.errorMessage = 'Tous les champs obligatoires doivent être remplis';
      return;
    }

    const payload: any = {
      title: this.form.title,
      description: this.form.description,
      applicationId: this.form.applicationId,
      daysOfWeek: this.form.daysOfWeek.length
        ? this.form.daysOfWeek
        : this.days.map(d => d.value),
      isUnlimitedTime: this.form.isUnlimitedTime
    };

    if (!this.form.isUnlimitedTime) {
      payload.startTime = this.form.startTime;
      payload.endTime = this.form.endTime;
      payload.intervalMinutes = this.form.intervalMinutes;
    }

    this.loading = true;

    this.notificationScheduleService.save( payload).subscribe({
      next: () => {
        this.successMessage = 'Notification planifiée avec succès';
        this.loading = false;
        this.resetForm();
      },
      error: () => {
        this.errorMessage = 'Erreur lors de l’envoi';
        this.loading = false;
      }
    });
  }

  resetForm() {
    this.form = {
      title: '',
      description: '',
      applicationId: 2,
      daysOfWeek: [],
      isUnlimitedTime: false,
      startTime: '',
      endTime: '',
      intervalMinutes: null
    };
  }

  toggleDay(dayValue: string, checked: boolean) {
  if (checked) {
    this.form.daysOfWeek.push(dayValue);
  } else {
    this.form.daysOfWeek = this.form.daysOfWeek.filter(d => d !== dayValue);
  }
  }

  toggleDays(day: string) {
  const i = this.form.daysOfWeek.indexOf(day);
  i > -1
    ? this.form.daysOfWeek.splice(i, 1)
    : this.form.daysOfWeek.push(day);
}

  goToList(): void {
    this.router.navigate(['/notifications']);
  }

}
